import { RAW_MATERIAL_RETURN_CHALLAN_TRANSACTION_REQUEST, GET_RAW_MATERIAL_RETURN_CHALLAN_TRANSACTIONS_TAKA_NO, RAW_MATERIAL_RETURN_CHALLAN_TRANSACTION_REQUEST_FAILURE,
  GET_RAW_MATERIAL_RETURN_CHALLAN_TRANSACTIONS } from '../types';

const initialState = {
  transactions: [],
  takaNos: [],
  loading: false,
  error: null,
};

const rawMaterialReturnChallanTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case RAW_MATERIAL_RETURN_CHALLAN_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_RAW_MATERIAL_RETURN_CHALLAN_TRANSACTIONS: {
      return {
        ...state,
        transactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_RAW_MATERIAL_RETURN_CHALLAN_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case RAW_MATERIAL_RETURN_CHALLAN_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default rawMaterialReturnChallanTransactionReducer;
